import { render } from "./TaggedText.vue?vue&type=template&id=0b8d8bec&scoped=true&ts=true"
import script from "./TaggedText.vue?vue&type=script&lang=ts"
export * from "./TaggedText.vue?vue&type=script&lang=ts"

import "./TaggedText.vue?vue&type=style&index=0&id=0b8d8bec&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8d8bec"]])

export default __exports__